import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnskipArrowIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M3.55 15.15c-.47.47-.47 1.23 0 1.695l6.8 6.805a1.2 1.2 0 0 0 1.695-1.695l-4.75-4.75h13.906c.665 0 1.2-.535 1.2-1.2s-.535-1.2-1.2-1.2H7.296l4.75-4.75A1.2 1.2 0 0 0 10.35 8.36zM27.2 6.4c-.884 0-1.6.715-1.6 1.6s.716 1.6 1.6 1.6c.886 0 1.6-.715 1.6-1.6s-.714-1.6-1.6-1.6m-1.6 6.935c0 .885.716 1.6 1.6 1.6.886 0 1.6-.715 1.6-1.6s-.714-1.6-1.6-1.6c-.884 0-1.6.715-1.6 1.6m1.6 3.73c-.884 0-1.6.715-1.6 1.6s.716 1.6 1.6 1.6c.886 0 1.6-.715 1.6-1.6s-.714-1.6-1.6-1.6M25.6 24c0 .885.716 1.6 1.6 1.6.886 0 1.6-.715 1.6-1.6s-.714-1.6-1.6-1.6c-.884 0-1.6.715-1.6 1.6" })
});
export default SvgUnskipArrowIcon;
